export const ControlType = {
  TextField: "textfield",
  CheckBox: "checkbox",
  DatePicker: "datepicker",
  AutoSearch: "autosearch",
  AutoComplete: "autocomplete",
};
